import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps & {
  onClick?: () => void;
};

export const MenuCloseIcon: FC<Props> = ({ className, onClick }) => (
  <svg onClick={onClick} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3334 13.3333L2.66675 2.66663M13.3334 2.66663L2.66675 13.3333"
      stroke="#272756"
      strokeWidth="2.07704"
      strokeLinecap="round"
    />
  </svg>
);
